import _implicitStylesheets from "./spinner.css";
import _implicitScopedStylesheets from "./spinner.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div style="position: relative"${3}><div role="status" class="slds-spinner slds-spinner_medium slds-spinner_brand${0}"${2}><div class="slds-spinner__dot-a${0}"${2}></div><div class="slds-spinner__dot-b${0}"${2}></div></div></div>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1)];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4s9t31iha26";
tmpl.legacyStylesheetToken = "undefined-_spinner";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
